import {
  EMAIL_VERIFICATION_REQUEST,
  EMAIL_VERIFICATION_SUCCESS,
  EMAIL_VERIFICATION_FAILURE,
  EMAIL_VERIFICATION_RESET
} from '../constants/emailVerificationConstants';

const initialState = {
  loading: false,
  success: false,
  error: null,
  message: ''
};

const emailVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_VERIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: action.payload,
        error: null
      };
    case EMAIL_VERIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        message: ''
      };
    case EMAIL_VERIFICATION_RESET:
      return initialState;
    default:
      return state;
  }
};

export default emailVerificationReducer;